//Aquí puede evaluar cómo condujo el estudiante. Hay N por Nuevo, R por Repetido, 3 para mal, 4 para suficiente y 5 para bien.
const colors = ["#ae0000", "#cd5757", "#fe6d00", "#dbca02", "#03de00"];

export const ratingTypes = [
  { id: "N", label: "New", color: colors[0] },
  { id: "R", label: "Repeat", color: colors[1] },
  { id: "3", label: "Bad", color: colors[2] },
  { id: "4", label: "Sufficient", color: colors[3] },
  { id: "5", label: "Good", color: colors[4] },
];
export const usersTypes = {
  student: "student",
  instructor: "instructor",
  admin: "admin",
};
export const accessTypes = { driving: "driving", VKU: "VKU" };
export const drivingCourseStatusTypes = {
  pending: "pending",
  inProgress: "inProgress",
  completed: "completed",
  canceled: "canceled",
};
export const drivingLessonsStatusTypes = {
  planned: "planned",
  waitingPayment: "waitingPayment",
  completed: "completed",
  cancelled: "cancelled",
};
export const courseCategoryType = {
  motorcycle: "motorcycle",
  firstAid: "firstAid",
  VKU: "VKU",
  drivingLessons: "drivingLessons",
};
export const courseCategory = [
  {
    name: "Driving Lessons",
    type: courseCategoryType.drivingLessons,
    maxStudents: 0,
    maxNumberClass: 30,
  },
  {
    name: "First Aid",
    type: courseCategoryType.firstAid,
    maxStudents: 12,
    maxNumberClass: 3,
  },
  {
    name: "VKU",
    type: courseCategoryType.VKU,
    maxStudents: 12,
    maxNumberClass: 3,
  },
  {
    name: "Motorcycle Basic Course",
    type: courseCategoryType.motorcycle,
    maxStudents: 12,
    maxNumberClass: 3,
  },
];

export const TEMPORAL_LOGIN_DISABLE = false;

export const WeekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const Gender = [
  {
    id: "other",
    name: "Other",
  },
  {
    id: "male",
    name: "Male",
  },
  {
    id: "female",
    name: "Female",
  },
];
